import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusCircleIcon } from 'assets/icons';
import { AddToEstimateButtonAndDialog } from 'components/AddToEstimate/AddToEstimateButtonAndDialog';
import { BUNDLES, MyStoreType } from 'domains/myStore/MyStore.types';
import { Flex, Icon, WhiteBlueButton } from 'UI';

const BundlesHeader = ({
  myStoreType,
  disabled,
  handleAddSection,
  handleAddToEstimateClick,
}: {
  myStoreType: MyStoreType;
  disabled: boolean;
  handleAddSection: () => void;
  handleAddToEstimateClick: (quantity?: number) => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <WhiteBlueButton outlined size={'large'} onClick={handleAddSection}>
        <Flex gap={8} align={'center'}>
          <Icon IconComponent={PlusCircleIcon} size={20} />
          {myStoreType === BUNDLES
            ? t('my_store.bundles.actions.add_bundle_type', 'Add a bundle type')
            : t('my_store.references.actions.add_new_category', 'Add new category')}
        </Flex>
      </WhiteBlueButton>
      <AddToEstimateButtonAndDialog
        buttonComponent={'button'}
        disabled={disabled}
        handleAddToEstimateClick={handleAddToEstimateClick}
      />
    </>
  );
};

export default BundlesHeader;
